<div class="client-profile">
  <mat-tab-group>
    <mat-tab label="Account Info" *ngIf="tenantName !== 'riskspongemaster'">
      <h1 *ngIf="isFirstLogin">Please provide required account information and hit Save</h1>
      <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start">
        <div style="display: flex; flex-direction: column; flex:50%">
          <div>
            <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">
              Customer
              Administrator
            </h2>
          </div>

          <div style="margin-bottom: 10px">
            <div *ngIf="model.clientCompany.logoFileName == null">
              <label class="mat-button mat-raised-button" for="clientCompanyLogo" matTooltip="{{this.constants.IMAGE_FILE_DESCRIPTION}}">
                <i class="pi pi-paperclip"></i> Attach Company Logo *
                <input id="clientCompanyLogo"
                       type="file"
                       accept="{{this.constants.IMAGE_FILE_EXTENSIONS}}"
                       (change)="addClientCompanyLogo($event)"
                       name="clientCompanyLogo"
                       style="display: none;" />
              </label>
            </div>
            <div *ngIf="model.clientCompany.logoFileName != null">
              <span (click)="downloadClientCompanyLogo()"
                    class="btn btn-link">
                {{ model.clientCompany.logoFileName }}
              </span>
              <label class="mat-button mat-raised-button" for="updateClientCompanyLogo" matTooltip="{{this.constants.IMAGE_FILE_DESCRIPTION}}">
                <i class="pi pi-paperclip"></i> Upload new Logo *
                <input id="updateClientCompanyLogo"
                       type="file"
                       accept="{{this.constants.IMAGE_FILE_EXTENSIONS}}"
                       (change)="addClientCompanyLogo($event)"
                       name="updateClientCompanyLogo"
                       style="display: none;" />
              </label>
            </div>
          </div>


          <mat-form-field class="example-full-width">
            <mat-label>First Name</mat-label>
            <input matInput
                   name="clientFirstName"
                   [(ngModel)]="model.manager.firstName"
                   pTooltip="Please enter client's first and last name so an account will be created for task assignment"
                   tooltipPosition="top">
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Last Name</mat-label>
            <input matInput
                   name="clientLastName"
                   [(ngModel)]="model.manager.lastName"
                   pTooltip="Please enter client's first and last name so an account will be created for task assignment"
                   tooltipPosition="top">
          </mat-form-field>
          <div style="flex:45%">
            <form>
              <mat-form-field class="example-full-width">
                <mat-label>E-mail</mat-label>
                <input matInput
                       [(ngModel)]="model.manager.emailAddress"
                       name="clientEmailAddress" />
              </mat-form-field>
            </form>
          </div>
          <mat-form-field class="example-full-width">
            <mat-label>Company Name</mat-label>
            <input matInput
                   name="clientCompanyName"
                   required
                   [(ngModel)]="model.clientCompany.companyName">
            <mat-error>This field is required</mat-error>
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label>Street Address</mat-label>
            <input matInput
                   name="clientStreetAddress"
                   [(ngModel)]="model.clientCompany.streetAddress">
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Suite/Room/Building</mat-label>
            <input matInput
                   name="clientSuiteRoomBuilding"
                   [(ngModel)]="model.clientCompany.suiteRoomBuilding">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label>City</mat-label>
            <input matInput
                   name="clientCity"
                   [(ngModel)]="model.clientCompany.city">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label>State</mat-label>
            <input matInput
                   name="clientState"
                   [(ngModel)]="model.clientCompany.state">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label>Zip</mat-label>
            <input matInput
                   name="clientZip"
                   [(ngModel)]="model.clientCompany.zip">
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Country</mat-label>
            <input matInput
                   name="clientCountry"
                   [(ngModel)]="model.clientCompany.country">
          </mat-form-field>

          <hr />
        </div>

        <div style="flex:5%; display: flex; flex-direction: column;"></div>

        <div style="display: flex; flex-direction: column; flex:50%">
          <div><h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Advisor Admin</h2></div>

          <div style="margin-bottom: 10px">
            <div *ngIf="model.consultantCompany.logoFileName == null">
              <label class="mat-button mat-raised-button" for="consultantCompanyLogo" matTooltip="{{this.constants.IMAGE_FILE_DESCRIPTION}}">
                <i class="pi pi-paperclip"></i> Attach Company Logo *
                <input id="consultantCompanyLogo"
                       type="file"
                       accept="image/*, .pdf"
                       (change)="addConsultantCompanyLogo($event)"
                       name="consultantCompanyLogo"
                       style="display: none;" />
              </label>
            </div>
            <div *ngIf="model.consultantCompany.logoFileName != null">
              <span (click)="downloadConsultantCompanyLogo()"
                    class="btn btn-link">
                {{ model.consultantCompany.logoFileName }}
              </span>
              <label class="mat-button mat-raised-button" for="updateConsultantCompanyLogo" matTooltip="{{this.constants.IMAGE_FILE_DESCRIPTION}}">
                <i class="pi pi-paperclip"></i> Upload new Logo *
                <input id="updateConsultantCompanyLogo"
                       type="file"
                       accept="{{this.constants.IMAGE_FILE_EXTENSIONS}}"
                       (change)="addConsultantCompanyLogo($event)"
                       name="updateConsultantCompanyLogo"
                       style="display: none;" />
              </label>
            </div>
          </div>


          <mat-form-field class="example-full-width">
            <mat-label>First Name</mat-label>
            <input matInput
                   name="consultantFirstName"
                   [(ngModel)]="model.advisorLead.firstName"
                   pTooltip="Please enter client's first and last name so an account will be created for task assignment"
                   tooltipPosition="top">
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Last Name</mat-label>
            <input matInput
                   name="consultantLastName"
                   [(ngModel)]="model.advisorLead.lastName"
                   pTooltip="Please enter client's first and last name so an account will be created for task assignment"
                   tooltipPosition="top">
          </mat-form-field>
          <div style="flex:45%">
            <form>
              <mat-form-field class="example-full-width">
                <mat-label>E-mail</mat-label>
                <input matInput
                       [(ngModel)]="model.advisorLead.emailAddress"
                       name="consultantEmailAddress" />
              </mat-form-field>
            </form>
          </div>
          <mat-form-field class="example-full-width">
            <mat-label>Company Name</mat-label>
            <input matInput
                   name="consultantCompanyName"
                   required
                   [(ngModel)]="model.consultantCompany.companyName">
            <mat-error>This field is required</mat-error>
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label>Street Address</mat-label>
            <input matInput
                   name="consultantStreetAddress"
                   [(ngModel)]="model.consultantCompany.streetAddress">
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Suite/Room/Building</mat-label>
            <input matInput
                   name="consultantSuiteRoomBuilding"
                   [(ngModel)]="model.consultantCompany.suiteRoomBuilding">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label>City</mat-label>
            <input matInput
                   name="consultantCity"
                   [(ngModel)]="model.consultantCompany.city">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label>State</mat-label>
            <input matInput
                   name="consultantState"
                   [(ngModel)]="model.consultantCompany.state">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <mat-label>Zip</mat-label>
            <input matInput
                   name="consultantZip"
                   [(ngModel)]="model.consultantCompany.zip">
          </mat-form-field>
          <mat-form-field class="example-full-width">
            <mat-label>Country</mat-label>
            <input matInput
                   name="consultantCountry"
                   [(ngModel)]="model.consultantCompany.country">
          </mat-form-field>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="LLM Blockchain" *ngIf="isElixirEnabled">
      <div style="display: flex; flex-direction: column; gap: 20px; padding: 20px">
        <h2>Large Language Model (LLM) Configuration</h2>
        <div *ngFor="let llm of llmProviders; let i = index"
             style="border: 1px solid #ccc; padding: 15px; border-radius: 8px;">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>LLM Provider</mat-label>
            <mat-select [(ngModel)]="llm.provider" name="llmProvider{{i}}">

              <mat-optgroup label="OpenAI">
                <mat-option value="openai-gpt-5">GPT-5</mat-option>
                <mat-option value="openai-gpt-4o">GPT-4o</mat-option>
                <mat-option value="openai-gpt-4">GPT-4</mat-option>
                <mat-option value="openai-gpt-3.5">GPT-3.5</mat-option>
              </mat-optgroup>

              <mat-optgroup label="Anthropic">
                <mat-option value="Anthropic-claude-opus-4-1-20250805">Claude Opus 4.1</mat-option>
                <mat-option value="Anthropic-claude-opus-4-20250514">Claude Opus 4</mat-option>
                <mat-option value="Anthropic-claude-sonnet-4-20250514">Claude Sonnet 4</mat-option>
                <mat-option value="Anthropic-claude-3.7-sonnet-20250219">Claude 3.7 Sonnet</mat-option>
              </mat-optgroup>


              <mat-optgroup label="Google">
                <mat-option value="Google-gemini-1.5-pro">Gemini 1.5 Pro</mat-option>
                <mat-option value="Google-gemini-2.5-pro">Gemini 2.5 Pro</mat-option>
                <mat-option value="Google-gemini-2.5-flash">Gemini 2.5 Flash</mat-option>
              </mat-optgroup>

              <mat-optgroup label="Meta">
                <mat-option value="Meta-llama-3.1-8b-instant">LLaMA 3.1 8B (Instant)</mat-option>
                <mat-option value="Meta-llama-3.1-70b-versatile">LLaMA 3.1 70B (Versatile)</mat-option>
              </mat-optgroup>


              <mat-optgroup label="Mistral">
                <mat-option value="Mistral-mistral-7b">Mistral 7B</mat-option>
                <mat-option value="Mistral-mixtral-8x7b">Mixtral 8×7B</mat-option>
              </mat-optgroup>


              <mat-optgroup label="Cohere">
                <mat-option value="Cohere-command-r">Command R</mat-option>
                <mat-option value="Cohere-command-r-plus">Command R+</mat-option>
              </mat-optgroup>

              <mat-optgroup label="Perplexity">
                <mat-option value="Perplexity-mixtral">Mixtral (Perplexity)</mat-option>
                <mat-option value="Perplexity-llama-3.1-70b">LLaMA 3.1 70B (Perplexity)</mat-option>
              </mat-optgroup>


            </mat-select>


          </mat-form-field>


          <mat-form-field class="example-full-width">
            <mat-label>API Key</mat-label>
            <input matInput [(ngModel)]="llm.encryptedApiKey" name="llmApiKey{{i}}" type="password"
                   (change)="onApiKeyChanged(llm)">
          </mat-form-field>

          <mat-radio-group [(ngModel)]="selectedActiveLlmId" name="activeLlm"
                           (ngModelChange)="onActiveLlmChange($event)" style="margin-top: 10px;">
            <mat-radio-button [value]="llm.id">Set as Active</mat-radio-button>
          </mat-radio-group>

          <br /><br />
          <button mat-raised-button color="warn" (click)="removeLLM(i)">Remove</button>
        </div>

        <button mat-raised-button style="background: orange; color: white;" (click)="addNewLLM()">Add LLM</button>
      </div>
      <ng-template #ackDialog>
        <h2 mat-dialog-title>LLM API Credential Acknowledgement</h2>
        <mat-dialog-content>
          <p>By entering your API key, you acknowledge that:</p>
          <ul>
            <li>The credentials will be securely stored and used for LLM access.</li>
            <li>You are responsible for usage and cost associated with the API key.</li>
            <li>You are not violating any terms of service of the LLM provider.</li>
          </ul>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-button (click)="dialogRef.close(false)">Cancel</button>
          <button mat-button color="primary" (click)="dialogRef.close(true)">I Agree</button>
        </mat-dialog-actions>
      </ng-template>
    </mat-tab>

    <mat-tab label="Settings">
      <div style="display: flex; flex-direction: column; flex:50%">
        
        <mat-form-field *ngIf="projects && projects.length">
          <mat-label>Select default project</mat-label>
          <mat-select [(ngModel)]="model.settings.defaultProject">
            <mat-option *ngFor="let project of projects" [value]="project.projectId">
              {{ project.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <h3>Legal Notice</h3>
        <mat-checkbox class="example-margin"
                      [(ngModel)]="firstLoginNoticeEnabled"
                      (change)="firstLoginNoticeChanged($event)"
                      name="enableFirstLoginNotice">
          Enable legal notice on first login
        </mat-checkbox>
        <mat-form-field>
          <mat-label>Legal Notice</mat-label>
          <textarea matInput
                    [(ngModel)]="model.settings.firstLoginNotice"
                    name="firstLoginNotice"
                    rows="5"
                    [disabled]="!firstLoginNoticeEnabled"
                    cols="50"></textarea>
        </mat-form-field>

        <h3>Security</h3>

        <mat-checkbox class="example-margin"
                      [(ngModel)]="model.settings.enableEmailMfa"
                      name="fP199Moderate">
          Enable Email-based Multi-Factor Authentication
        </mat-checkbox>
        <mat-checkbox class="example-margin"
                      [(ngModel)]="model.settings.enableTotpMfa"
                      name="fP199Moderate">
          Enable TOTP Multi-Factor Authentication
        </mat-checkbox>


        <mat-checkbox class="example-margin"
                      [checked]="model.settings.enableAzure && tenant && tenant.isAzureAuthenticationEnabled"
                      name="enableAzure">
          Enable Azure Authentication
        </mat-checkbox>

        <div><a [routerLink]="['/','azure']">Setup guide</a></div>

        <mat-form-field *ngIf="model.settings.enableAzure && tenant && tenant.isAzureAuthenticationEnabled">
          <mat-label>Application (client) ID</mat-label>
          <input matInput
                 [(ngModel)]="model.settings.azureApplicationId" />
        </mat-form-field>
        <mat-form-field *ngIf="model.settings.enableAzure && tenant && tenant.isAzureAuthenticationEnabled">
          <mat-label>Directory (tenant) ID</mat-label>
          <input matInput [(ngModel)]="model.settings.azureDirectoryId" />
        </mat-form-field>

        <mat-checkbox class="example-margin"
                      [disabled]="!(tenant && tenant.isOidcAuthenticationEnabled)"
                      [(ngModel)]="model.settings.enableOidc"
                      name="enableOidc">
          Enable OIDC Authentication
        </mat-checkbox>

        <div *ngIf="model.settings.enableOidc && tenant && tenant.isOidcAuthenticationEnabled">
          Add {{ oidcService.callbackUri(tenantName) }} to provider's allowed callback URLs
        </div>
        <mat-form-field *ngIf="model.settings.enableOidc && tenant && tenant.isOidcAuthenticationEnabled">
          <mat-label>Authority</mat-label>
          <input matInput
                 [(ngModel)]="model.settings.oidcAuthority" />
        </mat-form-field>
        <mat-form-field *ngIf="model.settings.enableOidc && tenant && tenant.isOidcAuthenticationEnabled">
          <mat-label>Config URL (if non-standard)</mat-label>
          <input matInput
                 [(ngModel)]="model.settings.oidcConfigUrl" />
        </mat-form-field>
        <mat-form-field *ngIf="model.settings.enableOidc && tenant && tenant.isOidcAuthenticationEnabled">
          <mat-label>Client ID</mat-label>
          <input matInput
                 [(ngModel)]="model.settings.oidcClientId" />
        </mat-form-field>
        <mat-form-field *ngIf="model.settings.enableOidc && tenant && tenant.isOidcAuthenticationEnabled">
          <mat-label>Client Secret</mat-label>
          <input matInput type="password"
                 [(ngModel)]="model.settings.oidcClientSecret" />
        </mat-form-field>


        <h3 *ngIf="tenant && (tenant.isOwnAmazonStorageEnabled || tenant.isOwnAzureStorageEnabled)">
          Bring Your Own
          Storage
        </h3>

        <mat-form-field style="width: 200px;"
                        *ngIf="tenant && (tenant.isOwnAmazonStorageEnabled || tenant.isOwnAzureStorageEnabled)">
          <mat-label>Artifacts</mat-label>
          <mat-select [(ngModel)]="model.settings.ownStorageType">
            <mat-option [value]="0">Default</mat-option>
            <mat-option [value]="1" *ngIf="tenant && tenant.isOwnAmazonStorageEnabled">Amazon S3</mat-option>
            <mat-option [value]="2" *ngIf="tenant && tenant.isOwnAzureStorageEnabled">Azure Blob Container</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="model.settings.ownStorageType == 1 && tenant && tenant.isOwnAmazonStorageEnabled"
             style="margin-left: 40px; display: flex; flex-direction: column;">
          <mat-form-field>
            <mat-label>S3 Access Key Id</mat-label>
            <input matInput [(ngModel)]="model.settings.s3AccessKeyId" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>S3 Access Key</mat-label>
            <input matInput [(ngModel)]="model.settings.s3AccessKey" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>S3 Region Name (ex. us-east-1)</mat-label>
            <input matInput [(ngModel)]="model.settings.s3Region" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>S3 Bucket</mat-label>
            <input matInput [(ngModel)]="model.settings.s3Bucket" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>S3 Root Folder on Bucket</mat-label>
            <input matInput [(ngModel)]="model.settings.s3RootFolder" />
          </mat-form-field>
        </div>
        <div *ngIf="model.settings.ownStorageType == 2 && tenant && tenant.isOwnAzureStorageEnabled"
             style="margin-left: 40px; display: flex; flex-direction: column;">
          <mat-form-field>
            <mat-label>Azure Storage Account Connection String</mat-label>
            <input matInput
                   [(ngModel)]="model.settings.azureConnectionString" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Azure Blob Container Name</mat-label>
            <input matInput
                   [(ngModel)]="model.settings.azureBlobContainerName" />
          </mat-form-field>
        </div>
        <mat-form-field style="width: 200px;">
          <mat-label>Data</mat-label>
          <mat-select [value]="0" [(ngModel)]="model.ownDataStorageType">
            <mat-option [value]="0">Default</mat-option>
            <mat-option [value]="1">Postgres Database</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="model.ownDataStorageType == 1"
             style="margin-left: 40px; display: flex; flex-direction: column;">
          <mat-form-field>
            <mat-label>Postgres Server</mat-label>
            <input matInput [(ngModel)]="model.dbSettings.postgressServer" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Postgres Database Name</mat-label>
            <input matInput [(ngModel)]="model.dbSettings.postgressDatabase" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Postgres Username</mat-label>
            <input matInput [(ngModel)]="model.dbSettings.postgressUsername" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Postgres Password</mat-label>
            <input matInput type="password" [(ngModel)]="model.dbSettings.postgressPassword" />
          </mat-form-field>
        </div>
        <h3>Data Export</h3>
        <a href="{{this.config.api + '/api/project/zip/create' + '?token=' + userToken}}">
          <span>Export All Account Data</span>
        </a>
        <h3>SSO</h3>
        <mat-form-field>
          <mat-label>SSO URL</mat-label>
          <input matInput [(ngModel)]="model.settings.inqSsoUrl" />
          <i class="pi pi-plus"></i>
        </mat-form-field>
        <h3>Scoring</h3>
        <mat-form-field style="width: 100px;">
          <mat-label>Implementation Status Score</mat-label>
          <input matInput [(ngModel)]="model.settings.implementationStatusScore" type="number" />
        </mat-form-field>
        <mat-form-field style="width: 100px;">
          <mat-label>Evidence Score</mat-label>
          <input matInput [(ngModel)]="model.settings.evidenceScore" type="number" />
        </mat-form-field>
        <mat-form-field style="width: 100px;">
          <mat-label>Policy Score</mat-label>
          <input matInput [(ngModel)]="model.settings.policyScore" type="number" />
        </mat-form-field>
        <mat-form-field style="width: 100px;">
          <mat-label>POAM Score</mat-label>
          <input matInput [(ngModel)]="model.settings.poamScore" type="number" />
        </mat-form-field>
      </div>
      <h3>Timeout</h3>
      <mat-form-field>
        <mat-label>Logout Timeout</mat-label>
        <input matInput type="number" [(ngModel)]="model.settings.inactivityTimeout" />
      </mat-form-field>
    </mat-tab>

    <mat-tab label="Look and Feel">
      <br />
      <mat-form-field style="width: 200px;">
        <mat-label>UI color</mat-label>
        <input matInput
               [(ngModel)]="model.settings.uiColor"
               name="uiColor"
               [value]="model.settings.uiColor">
        <p-colorPicker matSuffix [(ngModel)]="model.settings.uiColor"></p-colorPicker>
      </mat-form-field>
      <mat-form-field style="width: 200px;">
        <mat-label>Banner color</mat-label>
        <input matInput
               [(ngModel)]="model.settings.bannerColor"
               [value]="model.settings.bannerColor">
        <p-colorPicker matSuffix [(ngModel)]="model.settings.bannerColor"></p-colorPicker>
      </mat-form-field>
      <mat-form-field style="width: 200px;">
        <mat-label>Menu color</mat-label>
        <input matInput
               [(ngModel)]="model.settings.menuColor"
               [value]="model.settings.menuColor">
        <p-colorPicker matSuffix [(ngModel)]="model.settings.menuColor"></p-colorPicker>
      </mat-form-field>
      <mat-form-field style="width: 200px;">
        <mat-label>Menu Font color</mat-label>
        <input matInput
               [(ngModel)]="model.settings.menuFontColor"
               [value]="model.settings.menuFontColor">
        <p-colorPicker matSuffix [(ngModel)]="model.settings.menuFontColor"></p-colorPicker>
      </mat-form-field>
      <mat-form-field style="width: 200px;">
        <mat-label>Submenu Font color</mat-label>
        <input matInput
               [(ngModel)]="model.settings.subMenuFontColor"
               [value]="model.settings.subMenuFontColor">
        <p-colorPicker matSuffix [(ngModel)]="model.settings.subMenuFontColor"></p-colorPicker>
      </mat-form-field>
      <div class="theme-palette-section">
        <h3>Theme Palette</h3>
        <mat-button-toggle-group [value]="themePalette?.mode"
                                 (change)="onThemeModeChange($event.value)">
          <mat-button-toggle value="light">Light</mat-button-toggle>
          <mat-button-toggle value="dark">Dark</mat-button-toggle>
        </mat-button-toggle-group>
        <div class="theme-colors-grid">
          <mat-form-field style="width: 200px;">
            <mat-label>Primary</mat-label>
            <input matInput
                   [name]="'themePrimary'"
                   [(ngModel)]="themePalette.colors.primary"
                   (ngModelChange)="onThemeColorChange('primary', $event)">
            <p-colorPicker matSuffix
                           [(ngModel)]="themePalette.colors.primary"
                           (ngModelChange)="onThemeColorChange('primary', $event)"></p-colorPicker>
          </mat-form-field>
          <mat-form-field style="width: 200px;">
            <mat-label>Accent</mat-label>
            <input matInput
                   [name]="'themeAccent'"
                   [(ngModel)]="themePalette.colors.accent"
                   (ngModelChange)="onThemeColorChange('accent', $event)">
            <p-colorPicker matSuffix
                           [(ngModel)]="themePalette.colors.accent"
                           (ngModelChange)="onThemeColorChange('accent', $event)"></p-colorPicker>
          </mat-form-field>
          <mat-form-field style="width: 200px;">
            <mat-label>Background</mat-label>
            <input matInput
                   [name]="'themeBackground'"
                   [(ngModel)]="themePalette.colors.bg"
                   (ngModelChange)="onThemeColorChange('bg', $event)">
            <p-colorPicker matSuffix
                           [(ngModel)]="themePalette.colors.bg"
                           (ngModelChange)="onThemeColorChange('bg', $event)"></p-colorPicker>
          </mat-form-field>
          <mat-form-field style="width: 200px;">
            <mat-label>Surface</mat-label>
            <input matInput
                   [name]="'themeSurface'"
                   [(ngModel)]="themePalette.colors.surface"
                   (ngModelChange)="onThemeColorChange('surface', $event)">
            <p-colorPicker matSuffix
                           [(ngModel)]="themePalette.colors.surface"
                           (ngModelChange)="onThemeColorChange('surface', $event)"></p-colorPicker>
          </mat-form-field>
          <mat-form-field style="width: 200px;">
            <mat-label>Surface 2</mat-label>
            <input matInput
                   [name]="'themeSurface2'"
                   [(ngModel)]="themePalette.colors.surface2"
                   (ngModelChange)="onThemeColorChange('surface2', $event)">
            <p-colorPicker matSuffix
                           [(ngModel)]="themePalette.colors.surface2"
                           (ngModelChange)="onThemeColorChange('surface2', $event)"></p-colorPicker>
          </mat-form-field>
          <mat-form-field style="width: 200px;">
            <mat-label>Text</mat-label>
            <input matInput
                   [name]="'themeText'"
                   [(ngModel)]="themePalette.colors.text"
                   (ngModelChange)="onThemeColorChange('text', $event)">
            <p-colorPicker matSuffix
                           [(ngModel)]="themePalette.colors.text"
                           (ngModelChange)="onThemeColorChange('text', $event)"></p-colorPicker>
          </mat-form-field>
          <mat-form-field style="width: 200px;">
            <mat-label>Muted</mat-label>
            <input matInput
                   [name]="'themeMuted'"
                   [(ngModel)]="themePalette.colors.muted"
                   (ngModelChange)="onThemeColorChange('muted', $event)">
            <p-colorPicker matSuffix
                           [(ngModel)]="themePalette.colors.muted"
                           (ngModelChange)="onThemeColorChange('muted', $event)"></p-colorPicker>
          </mat-form-field>
        </div>
        <div class="border-strength-row">
          <label class="border-label">Border strength</label>
          <input type="range"
                 min="0.04"
                 max="0.2"
                 step="0.01"
                 [value]="borderStrength"
                 (input)="onBorderStrengthChange($any($event.target).valueAsNumber)" />
          <span class="border-value">{{ borderStrength | number:'1.2-2' }}</span>
        </div>
        <div class="chart-palette-section">
          <h4>Chart Palette</h4>
          <div class="chart-palette-grid">
            <mat-form-field *ngFor="let color of themePalette.chartPalette; let i = index" style="width: 160px;">
              <mat-label>Color {{ i + 1 }}</mat-label>
              <input matInput
                     [name]="'chartPalette' + i"
                     [(ngModel)]="themePalette.chartPalette[i]"
                     (ngModelChange)="onChartPaletteChange(i, $event)">
              <p-colorPicker matSuffix
                             [(ngModel)]="themePalette.chartPalette[i]"
                             (ngModelChange)="onChartPaletteChange(i, $event)"></p-colorPicker>
            </mat-form-field>
          </div>
        </div>
        <button mat-stroked-button type="button" (click)="resetThemeDefaults()">Reset to defaults</button>
      </div>

      <mat-form-field style="width: 200px;">
        <mat-label>Footer Text</mat-label>
        <input matInput
               [(ngModel)]="model.settings.footer">
      </mat-form-field>
      <mat-form-field style="width: 200px;">
        <mat-label>Login Footer Text</mat-label>
        <input matInput
               [(ngModel)]="model.settings.loginFooter">
      </mat-form-field>
      <mat-form-field style="width: 200px;">
        <mat-label>Login Button color</mat-label>
        <input matInput
               [(ngModel)]="model.settings.loginButtonColor"
               [value]="model.settings.loginButtonColor">
        <p-colorPicker matSuffix [(ngModel)]="model.settings.loginButtonColor"></p-colorPicker>
      </mat-form-field>
      <div style="margin-left: 15px;">
        <label class="mat-button mat-raised-button" for="loginImage" matTooltip="{{this.constants.IMAGE_FILE_DESCRIPTION}}">
          <i class="pi pi-paperclip"></i> Login Image
          <input id="loginImage"
                 type="file"
                 accept="{{this.constants.IMAGE_FILE_EXTENSIONS}}"
                 (change)="addLoginImage($event)"
                 name="loginImage"
                 style="display: none;" />
        </label>
        <img style="max-width: 50px; max-height:50px; margin-left: 20px;" [src]="loginImageUrl"
             *ngIf="model.settings.loginImage" />
      </div>
      <div style="margin-left: 15px;">
        <label class="mat-button mat-raised-button" for="loginLogo" matTooltip="{{this.constants.IMAGE_FILE_DESCRIPTION}}">
          <i class="pi pi-paperclip"></i> Login Logo
          <input id="loginLogo"
                 type="file"
                 accept="{{this.constants.IMAGE_FILE_EXTENSIONS}}"
                 (change)="addLoginLogo($event)"
                 name="loginLogo"
                 style="display: none;" />
        </label>
        <img style="max-width: 50px; max-height:50px; margin-left: 20px;" [src]="loginLogoUrl"
             *ngIf="model.settings.loginLogo" />
      </div>
      <mat-form-field style="width: 200px;">
        <mat-label>Login Panel Background</mat-label>
        <input matInput
               [(ngModel)]="model.settings.loginPanelBackground"
               [value]="model.settings.loginPanelBackground">
        <p-colorPicker matSuffix [(ngModel)]="model.settings.loginPanelBackground"></p-colorPicker>
      </mat-form-field>

    </mat-tab>


    <mat-tab label="Data" *ngIf="tenantName !== 'riskspongemaster'">

      <mat-accordion multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Menu
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div *ngFor="let label of labels">
            <mat-form-field>
              <mat-label>{{ label }}</mat-label>
              <input matInput [(ngModel)]="model.settings.menuLabels[label]" />
            </mat-form-field>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              RizkList – Organizations
            </mat-panel-title>
          </mat-expansion-panel-header>

          <rizkListConfig-component [mode]="'organizations'">
          </rizkListConfig-component>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              RizkList – Scoring
            </mat-panel-title>
          </mat-expansion-panel-header>

          <rizkListConfig-component [mode]="'scoring'">
          </rizkListConfig-component>
        </mat-expansion-panel>

      </mat-accordion>

    </mat-tab>



    <mat-tab label="License" *ngIf="tenantName !== 'riskspongemaster'">
      <license></license>
    </mat-tab>
  </mat-tab-group>
  <div class="form-group" style="margin-top: 29px;">
    <button mat-raised-button
            style="border-radius: 6px;"
            (click)="onSave()">
      {{ isFirstLogin && !isClientManager ? "Save & Create Project" : "Save" }}
    </button>
    <img *ngIf="loading"
         src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
    <button mat-raised-button [routerLink]="['/home']">Cancel</button>
  </div>
</div>
